import React from 'react';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import cn from 'classnames';
import { extConfig } from './config';
import GroupAboutBubbleMenu from '../../../menus/GroupAboutBubbleMenu';

import viewerStyles from '../../../Viewer/presets/AdminNote/AdminNote.scss';
import s from './AdminNote.scss';

export interface Props
  extends Omit<EditorProps, 'extensionConfig' | 'presetId'> {
  validationResult?: 'success' | 'error';
}

const AdminNoteEditor: React.FC<Props> = ({
  validationResult = 'success',
  ...props
}) => {
  return (
    <Editor
      {...props}
      withinModal
      presetId="adminnote"
      className={cn(
        s['root'],
        viewerStyles['root'],
        validationResult == 'error' && s['error']
      )}
      extensionConfig={extConfig}
    >
      {(editor, scrollContainer) => (
        <GroupAboutBubbleMenu scrollContainerRef={scrollContainer} />
      )}
    </Editor>
  );
};
AdminNoteEditor.displayName = 'AdminNoteEditor';

export default AdminNoteEditor;
